export default __webpack_public_path__ + "static/media/film-reel.dbc7d0a4.png";